import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  app: {
    display: "flex",
    width: "100%",
    alignItems: "stretch",
  },
  rowStyle: {
    display: "flex",
    marginTop: "20px",
    justifyContent: "space-evenly",
  },
  expanded: {
    width: "50%",
    float: "right",
    zIndex: "800",
    transition: "all 0.5s",
  },
  cardbody: {
    marginBottom: "10px !important",
    padding: "10px !important",
    paddingBottom: "0 !important",
    backgroundColor: "white",
    border: "1px solid lightgray",
  },
  textRight: {
    flex: "1",
    float: "right",
    fontSize: "16px",
  },
  imgiconstyle: {
    width: "90px",
    height: "80px",
  },
  bgColor: {
    backgroundColor: "#f7f7f7",
    minHeight: "calc(98vh - 118px)",
    padding: "20px",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    "@media (max-width: 575.98px)": {
      padding: "10px",
    },
  },
  dateFilterWrapper: {
    margin: "3em 0em 0.5em 1em",
    "@media (max-width: 767.98px)": {
      margin: "1.5em 0em 0.5em 0.25em",
    },
  },
  categoriesRow: {
    padding: "1em",
    "@media (max-width: 575.98px)": {
      padding: "0.5em 0.25em",
    },
  },
  textStyle: {
    fontSize: "14px",
  },
  tooltip: {
    cursor: "pointer",
  },
  tooltiptextLeft: {
    visibility: "hidden",
    minWidth: "130px",
    backgroundColor: "#FFF",
    color: "black",
    textAlign: "center",
    borderRadius: "6px",
    padding: "4px",
    position: "absolute",
    fontSize: "12px",
    zIndex: 700,
    bottom: "100%",
    left: "50%",
    marginLeft: "-60px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
    "::after": {
      content: "",
      position: "absolute",
      top: "100%",
      left: "50%",
      marginLeft: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderColor: "rgba(0,0,0,0.24) transparent transparent transparent",
    },
  },
  abnormalMotionStart: {
    color: "green",
    marginTop: 0,
    textAlign: "end",
  },
  active: {
    color: "green",
    marginTop: 0,
    textAlign: "end",
  },
  generic: {
    color: "red",
    marginTop: 0,
    textAlign: "end",
  },
  patientMedicationCount: {
    color: "green",
    marginTop: 0,
    textAlign: "end",
  },
  abnormalMotionEnd: {
    color: "red",
    marginTop: 0,
    textAlign: "end",

  },
  total: {
    color: "red",
    marginTop: 0,
    textAlign: "top",

  },
  inactive: {
    color: "red",
    marginTop: 0,
    textAlign: "end",

  },
  abnormalMotionInProgress: {
    color: "#ffc107",
    marginTop: 0,
    textAlign: "end",

  },
  'in-development': {
    color: "#ffc107",
    marginTop: 0,
    textAlign: "end",

  },
  subLabelStyle: {
    fontWeight: 700,
  },
  subLabelStyle2: {
    fontSize: "14px"
  },
  cardBodyStyle: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: "10px",
    borderRadius: "15px",
    position: "relative",
  },
  colStyle: {
    marginBottom: "1em"
  },
  iconStyle: {
    width: "60px",
    height: "60px"
  },
  noLink: {
    cursor: "default"
  },
  activationBanner: {
    backgroundColor: '#ffc107',
    color: '#000',
    textAlign: 'center',
    padding: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    position: "relative",
    zIndex: 99
  },
});


export default styles;
